var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4393 6.27235C16.3677 6.26073 16.2953 6.25537 16.2228 6.25631H3.88358L4.15264 6.13117C4.41564 6.00669 4.6549 5.83728 4.8597 5.63059L8.31993 2.17036C8.77565 1.73533 8.85222 1.0355 8.50139 0.512206C8.09307 -0.0454281 7.31002 -0.166505 6.75235 0.241817C6.7073 0.274823 6.66447 0.310802 6.62423 0.349518L0.367034 6.60672C-0.121966 7.09517 -0.122396 7.88753 0.366056 8.37653C0.366369 8.37684 0.366721 8.37719 0.367034 8.3775L6.62423 14.6347C7.11362 15.1227 7.90598 15.1216 8.39404 14.6322C8.43244 14.5937 8.46831 14.5527 8.50139 14.5096C8.85222 13.9863 8.77565 13.2864 8.31993 12.8514L4.86596 9.38491C4.68235 9.20111 4.47125 9.04698 4.24024 8.92814L3.86481 8.75919H16.1539C16.7932 8.78293 17.3541 8.33636 17.4742 7.70798C17.5848 7.02575 17.1215 6.38302 16.4393 6.27235Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.0f33a998.svg";
export { ForwardRef as ReactComponent };